module.exports = __webpack_public_path__ + "src/img/reportIcon.f05a65b9.svg";